import { ParamMap, Params } from '@angular/router';
import { Pagination, SortDirectionFinancing } from '@lsq-frontend/angular-shared/api-service';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';
import { RouteQueryParams } from '@lsq-frontend/angular-shared/app-constants';
import { ITableColumn } from '../table/models/table-column';

export function patchColumns(
    columns: ITableColumn[],
    columnKeyToReplace: string,
    newColumn: ITableColumn
): ITableColumn[] {
    const indexOfColumn = columns.findIndex((column) => column.key === columnKeyToReplace);
    const newColumns = [...columns];
    newColumns.splice(indexOfColumn, 1, newColumn);
    return newColumns;
}

export class TableHelper {
    public static getQueryParamsByListSource(
        listSource: LsqApiServiceListSource<any, any, any>
    ): Params {
        return {
            [RouteQueryParams.Skip]: listSource.skip || undefined,
            [RouteQueryParams.Take]: listSource.take || undefined,
            [RouteQueryParams.SortColumn]: listSource.sortColumn || undefined,
            [RouteQueryParams.SortDirection]: listSource.sortDirection || undefined
        };
    }

    public static getPaginationByQueryParams(paramMap: ParamMap): Pagination {
        const skip = paramMap.get(RouteQueryParams.Skip);
        const sortColumn = paramMap.get(RouteQueryParams.SortColumn);
        const sortDirection = paramMap.get(RouteQueryParams.SortDirection);
        const take = paramMap.get(RouteQueryParams.Take);
        return new Pagination({
            skip: skip ? Number(skip) : undefined,
            sortColumn,
            sortDirection: sortDirection ? SortDirectionFinancing[sortDirection] : undefined,
            take: take ? Number(take) : undefined
        });
    }
}
